import { Box, Typography } from "@mui/material";

const PlanDetailInfoCard = ({
    icon,
    title,
    value,
    days,
    subValue,
    highlightText,
}) => {
    return (
        <Box
            bgcolor="background.primary01"
            borderRadius={2}
            px={2}
            py={1}
            display="flex"
            alignItems="center"
            gap={1.5}
            minHeight={88}
        >
            <Box
                sx={{
                    width: 42,
                    height: 42,
                    minWidth: 42,
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(121, 34, 216, 0.16)",
                    color: "primary.main",
                }}
            >
                {icon}
            </Box>

            <Box sx={{ minWidth: 0 }}>
                {title && (
                    <Typography variant="body2" color="text.secondary" lineHeight={1.2}>
                        {title}
                    </Typography>
                )}
                {value && (
                    <Typography variant="h6" fontWeight={700} lineHeight={1.2}>
                        {value}
                    </Typography>
                )}
                {days && (
                    <Typography variant="body2" color="success.main" mt={0.2}>
                        {days}
                    </Typography>
                )}
                {subValue && (
                    <Typography variant="body2" color="text.secondary" mt={0.2}>
                        {subValue}
                    </Typography>
                )}
                {highlightText && (
                    <Typography variant="body2" color="success.main" mt={0.2}>
                        {highlightText}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}

export default PlanDetailInfoCard;   